const StaffReducer = (state = { attachmentList: [], staffSearchFilters: [], searchStaffList: [] }, action) => {
    switch (action.type) {
        case "GET_STAFF_ATTACHMENTS":
            return {
                ...state,
                attachmentList: action.data
            }
        case "STAFF_SEARCH_FILTERS":
            return {
                ...state,
                staffSearchFilters: action.data
            }
        case "SEARCH_STAFF":
            return {
                ...state,
                searchStaffList: action.data
            }
        default:
            return state
    }
}
export default StaffReducer;